import { Component, Input, OnInit } from "@angular/core";
import { NgxSpinnerService } from "ngx-spinner";
import * as SecureLS from "secure-ls";
import { GlobalService } from "src/app/services/global.service";
import * as moment from "moment";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { ErrorModalComponent } from "../../error-modal/error-modal.component";
import { StorageService } from "../../../services/storage.service";
@Component({
  selector: "app-staff-usage-popup",
  templateUrl: "./staff-usage-popup.component.html",
  styleUrls: ["./staff-usage-popup.component.css"],
})
export class StaffUsagePopupComponent implements OnInit {
  private ls = new SecureLS({ encodingType: "aes" });
  @Input() selectedList;
  @Input() filter_from;
  @Input() filter_end;
  countvalue: number = 0;
  allVideoDetails: any[] = [];
  getAllVideoDetails: any;
  allVideoDetailsCountvalue: number = 0;
  page: number = 1;
  total: number;
  p: number;
  pagedItems: any[];
  page_size: number = 10;
  pageshow: boolean = true;
  role: any;
  ishod: any;
  department: any;
  total_count = 0;
  htmlpageshow: boolean;
  showLoadMore = false;
  page_count = [];

  constructor(
    private storageService: StorageService,
    private spinner: NgxSpinnerService,
    public globalService: GlobalService,
    private modalService: NgbModal
  ) {
    this.role = this.storageService.getRole();
    this.ishod = this.storageService.getHod();
  }

  ngOnInit() {
    this.getAllVideoDetailsPage();
  }

  async getPage(page: number) {
    this.page = page;
    await this.getAllVideoDetailsPage();
    const res = await this.serverCall(this.allVideoDetails, page);
    this.total = this.selectedList.video_total;
    this.pagedItems = res;
  }

  async serverCall(sample: any[], page: number) {
    const perPage = this.page_size;
    const start = (page - 1) * perPage;
    const end = start + perPage;
    return sample;
  }

  loadMore(index) {
    this.pageshow = true;
    this.page = index;
    this.getAllVideoDetailsPage();
  }

  previous() {
    this.pageshow = true;
    this.page = this.page - 1;
    this.getAllVideoDetailsPage();
  }

  next() {
    this.pageshow = true;
    this.page = this.page + 1;
    this.getAllVideoDetailsPage();
  }

  openErrorModal(errMsg,id) {
    if (errMsg) {
      const errorModalComp = this.modalService.open(ErrorModalComponent, {
        scrollable: true,
        size: 'lg'
      });
      errorModalComp.componentInstance.id = id;
      errorModalComp.componentInstance.errMsg = errMsg
        ? errMsg
        : "--No Error Message--";
    }
  }

  async getAllVideoDetailsPage() {
    this.allVideoDetails = [];
    this.spinner.show();
    let filter = {
      user_id: this.ls.get("createdBy"),
      vendor_id: this.ls.get("vendor_id"),
      professor_id: this.selectedList.professor_id,
      department_id: this.selectedList.department_id
        ? this.selectedList.department_id
        : this.storageService.getDepartment(),
      summary_type: this.selectedList.summary_type,
      classroom_id :this.selectedList.classroom_id,
      subject_id : this.selectedList.subject_id,
      batch_id: this.selectedList.batch_id,
      camera_start: this.filter_from,
      camera_end: this.filter_end,
      page: this.page,
      page_size: this.page_size,
    };
    this.getAllVideoDetails = await this.globalService.get(
      "classVideoDetail/get-all-video-details",
      filter
    );
    this.allVideoDetails = this.getAllVideoDetails["content"]["rows"];
    this.selectedList.video_total = this.getAllVideoDetails["content"].count;
    if (this.getAllVideoDetails["content"]["rows"].length > this.page_size) {
      this.showLoadMore = true;
    }
    if (this.getAllVideoDetails["status"] === 200) {
      this.allVideoDetails = this.getAllVideoDetails["content"]["rows"];
      if (this.pageshow === true) {
        this.page_count = [];
        let page_count = Math.ceil(
          this.selectedList.video_total / this.page_size
        );
        if (page_count > 1) {
          this.htmlpageshow = true;
        } else {
          this.htmlpageshow = false;
        }
      }
      this.spinner.hide();
    } else {
      this.showLoadMore = true;
    }
  }

  getUtcToLocale(dateValue, timeValue, isDateRequested) {
    return this.globalService.getUtcToLocale(dateValue, timeValue, isDateRequested);
  }

  paginationCount(value) {
    this.page = 1;
    this.page_size = value;
    this.getAllVideoDetailsPage();
  }
}
